var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(0 -0.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 20,
    height: 20,
    transform: "translate(0 0.207)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M1781.04,1776.193v-.032a.98.98,0,0,0-.979-.979h-.032A1.012,1.012,0,0,1,1781.04,1776.193Z",
    transform: "translate(-1762.661 -1769.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M1702.883,1774.189a1.867,1.867,0,0,1-.914-.238v9.163a2.415,2.415,0,0,0,2.339,2.479h9.89v-.509a3.551,3.551,0,0,1,3.547-3.547h.333v-3.467h-.333a3.551,3.551,0,0,1-3.547-3.547v-.333h-11.315Zm6.95,6.4a4.576,4.576,0,0,0-.816-.26,7.5,7.5,0,0,1-1.005-.322,1.793,1.793,0,0,1-.689-.511,1.4,1.4,0,0,1-.293-.932,1.573,1.573,0,0,1,.462-1.13,2.29,2.29,0,0,1,1.22-.635v-.94h1.154v.907a4.238,4.238,0,0,1,.89.218,2.245,2.245,0,0,1,.668.367l-.47,1.072a3.548,3.548,0,0,0-.808-.392,2.5,2.5,0,0,0-.783-.136,1.089,1.089,0,0,0-.606.149.473.473,0,0,0-.227.42.406.406,0,0,0,.144.317,1,1,0,0,0,.358.2q.214.07.61.169a7.389,7.389,0,0,1,.989.3,1.635,1.635,0,0,1,.676.5,1.438,1.438,0,0,1,.28.932,1.569,1.569,0,0,1-.458,1.138,2.262,2.262,0,0,1-1.232.618v.932h-1.154v-.9a4.113,4.113,0,0,1-.985-.194,2.88,2.88,0,0,1-.787-.392l.47-1.072a3.117,3.117,0,0,0,1.731.519q.907,0,.907-.577A.388.388,0,0,0,1709.833,1780.594Z",
    transform: "translate(-1699.699 -1768.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M1702.945,1760.411a.988.988,0,0,0-.977.977.926.926,0,0,0,.914.914h9.952v-1.89Z",
    transform: "translate(-1699.699 -1757.163)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M1772.772,1778.1h.333v-1.9a1.012,1.012,0,0,0-1.01-1.01h-1.9v.333A2.583,2.583,0,0,0,1772.772,1778.1Z",
    transform: "translate(-1754.726 -1769.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M1770.192,1820.75v.333h1.935a.979.979,0,0,0,.979-.978v-1.935h-.333A2.583,2.583,0,0,0,1770.192,1820.75Z",
    transform: "translate(-1754.726 -1803.75)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCash);
export default __webpack_public_path__ + "static/media/white_cash.8f33132f0ba50eca094fef0af228f339.svg";
export { ForwardRef as ReactComponent };